import { jsx as _jsx } from "react/jsx-runtime";
import { localInputSearchDebounceDelay, serverInputSearchDebounceDelay } from '@/core/constants';
import { forwardRef, useCallback, useEffect, useState } from 'react';
import { useDebounce } from '@/core/hooks';
import { t } from '@/core/localization';
import { TextFieldUncontrolledHighlighted } from './SearchTextField.styled';
/**
 * `TextField` intended for `server` or `local` search with specified character input debounce.
 *
 * Trimming of entered value is included by default, and the value is also transformed to lower case.
 *
 * @param debounce input debounce.
 * @param placeholder input placeholder.
 * @param defaultValue use not to lose actual value on mount/unmount, if value is stored in redux state.
 * @param highlightWhenFilled warns the user that field is not empty.
 * @param onChange on search input change handler.
 */
const SearchTextField = forwardRef(({ debounce = 'server', placeholder, highlightWhenFilled, onChange, ...props }, ref) => {
    const [searchTerm, setSearchTerm] = useState('');
    const debounceDelay = debounce === 'server' ? serverInputSearchDebounceDelay : debounce === 'local' ? localInputSearchDebounceDelay : debounce;
    const debouncedSearchTerm = useDebounce(searchTerm, debounceDelay);
    const onSearchChange = useCallback((event) => {
        setSearchTerm(event.target.value.trim());
    }, []);
    useEffect(() => {
        onChange(debouncedSearchTerm.toLocaleLowerCase());
    }, [onChange, debouncedSearchTerm]);
    return (_jsx(TextFieldUncontrolledHighlighted, { ref: ref, ...props, highlighted: highlightWhenFilled && Boolean(searchTerm.trim().length), placeholder: placeholder || t('search.label'), onChange: onSearchChange }));
});
export { SearchTextField };
